<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Complete your <span>My Stoke</span> registration'"
      :body="'<p>In order to complete your registration you must indicate that you have read and understood our privacy policy. </p>'" />
    <PageIntro v-else
      :heading="'Complete your <span>My Stoke</span> registration'"
      :body="''" />
    <Registration />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>

<script>
  import Registration from '@/components/PostSocialRegistration'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      Registration,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
